export default function injectDates(feature, dateKeys) {
  const featureIsoDatesObj = {};
  dateKeys.forEach((item) => {
    const isoDate = new Date(feature.attributes[item])
      .toISOString()
      .split("T")[0];
    featureIsoDatesObj[`${item}_ISO`] = isoDate;
  });
  return featureIsoDatesObj;
}
